import * as React from 'react';

import type { EventProcedureStepAPIType } from 'security-app/hooks/api/eventProceduresAPI.types';

import StepActionButton from './StepActionButton';

type Props = {
  title?: string;
  config: EventProcedureStepAPIType['action']['config'];
};

function StepGoToLink({ config, title = undefined }: Props) {
  const { link } = config;
  const clickableLink = link.startsWith('http://') || link.startsWith('https://') ? link : `https://${link}`;

  return <StepActionButton title={title || 'Go to Link'} to={clickableLink} />;
}

export default StepGoToLink;
